import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseMutationResult, useMutation } from "@tanstack/react-query";
import { handleJsonApiError } from "jsonapi-zod-query";

export const useExportPlaces = (): UseMutationResult<void, Error, void> => {
    const fetch = useAuthenticatedFetch();

    return useMutation({
        mutationFn: async () => {
            const response = await fetch(apiUrl("/company/export"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
            });

            if (response.ok) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;

                const contentDisposition = response.headers.get("content-disposition");
                let filename = `Places-Export-${new Date().toISOString().slice(0, 10)}.zip`;

                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename=([^;]+)/i);

                    if (filenameMatch) {
                        filename = filenameMatch[1].trim();
                    }
                }

                a.download = filename;

                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
            } else {
                await handleJsonApiError(response);
            }
        },
    });
};
